module Client.Training

open Elmish
open Fable.React
open Fable.React.Props
open Shared.Domain
open System
open Fetch
open Shared

type Workflow =
    | Checking
    | Error of string
    | Redirecting

type Model =
    {
        Step: Workflow
        Destination: string
        EnvironmentKey: string
    }

type Msg =
    | AuthError of exn
    | LoginResponseOnServer of LoginResponse
    | LoginFailure of exn
    | StoredLoginOnClient of JWT

module Commands =
    let login tenant token =
        let url = sprintf Urls.fmtLoginEndpoint tenant token
        FetchRequest.postNoDTO url LoginResponseOnServer AuthError

    let storeLoggedInUserCmd (newUser: JWT) = 
        Cmd.OfFunc.either 
            (BrowserLocalStorage.save "user") 
            newUser 
            (fun _ -> StoredLoginOnClient newUser) 
            AuthError

let init envKey token url =
    {
        Step = Checking
        Destination = url
        EnvironmentKey = envKey
    }, Commands.login envKey token

let update msg model =
    match msg with
    | AuthError exn | LoginFailure exn ->
        { model with Step = Error exn.Message }, []
    | LoginResponseOnServer response ->
        match response with
        | SignIn jwt ->
            model, Commands.storeLoggedInUserCmd jwt
        | LoginResponse.LoginFailure rsn ->
            printfn "Failed to log in: %s" rsn
            { model with Step = Error rsn }, []
    | StoredLoginOnClient _ -> 
        let page = Pages.Page.InfoPage ("training", model.Destination)
        model,Elmish.Navigation.Navigation.newUrl (Pages.toHash page)

let view model dispatch =
    [
        nav [ ClassName "navbar navbar-default navbar-fixed-top navbar-inverse" ] []
        div [ ClassName "container" ] [
            div [ ClassName "homeBanner" ] [
                div [ ClassName "center" ] [
                    yield h1 [] [ str "Training Login" ]
                    match model.Step with
                    | Checking ->
                        yield p [ Style [ Color "white" ] ] [ str "Checking that you are logged in to LINKS CarePath... " ]
                    | Error err ->
                        yield div [ ClassName "alert alert-warning" ] [
                            str "We could not detect your login to LINKS CarePath. Please log into it and try again: "
                            str err
                        ]
                    | Redirecting ->
                        yield p [ Style [ Color "white" ] ] [ str "Moving you on to your page..." ]
                ]
            ] 
        ]
    ]